import app from 'flarum/forum/app';
import addHelpRulesMenus from './addHelpRulesMenus';
export { default as extend } from './extend';
app.initializers.add('champis-help_rules', () => {
  addHelpRulesMenus();
});